import { reportError } from 'j-comps'
import { store } from '..'
import {
  canvaCustomSocialTypes,
  canvaRegularTypes,
  canvaSocialTypes,
} from '../constants'

export const formatBytes = (a, b) => {
  if (0 === a || !a) return '0 Bytes'
  var c = 1024,
    d = b || 2,
    e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    f = Math.floor(Math.log(a) / Math.log(c))
  return parseFloat((a / Math.pow(c, f)).toFixed(d)) + ' ' + e[f]
}

export const getCanvaTypes = () => {
  const allSocialTypes = [...canvaCustomSocialTypes, ...canvaSocialTypes]
  const sortedSocialTypes = allSocialTypes.sort((a, b) => {
    return a.name < b.name ? -1 : 1
  })
  const allRegularTypes = [...canvaRegularTypes]
  const sortedRegularTypes = allRegularTypes.sort((a, b) => {
    return a.name < b.name ? -1 : 1
  })

  try {
    const allTypes = [...sortedSocialTypes, ...sortedRegularTypes]
    return allTypes
  } catch (catchError) {
    const errorMessage = `Could not get Canva Types`
    reportError(store, errorMessage, catchError)
  }
}
